type EventCallback<T> = (detail: T) => void;

class EventBus {
  emit<T>(eventName: string, detail?: T): void {
    const event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);
  }

  on<T>(eventName: string, callback: EventCallback<T>): () => void {
    const handler = (event: CustomEvent<T>) => callback(event.detail);
    window.addEventListener(eventName, handler as EventListener);
    return () =>
      window.removeEventListener(eventName, handler as EventListener);
  }
}

export const eventBus = new EventBus();
